// extracted by mini-css-extract-plugin
export default {"icon":"Literature_icon__RWc09"};